module.exports = __webpack_public_path__ + "img/5.88a3a64d.jpg";